// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cA98L5hbZ94cB04Zdtkl {
  position: fixed;
  right: 1em;
  bottom: 4em;
  z-index: 99;
  background-color: var(--bar-background);
  width: 45vw;
  height: 15vh;
  padding: 1.2rem 0.5rem 0.5rem 3.5rem;
  border-radius: var(--dry-border-radius);
}
.cA98L5hbZ94cB04Zdtkl > .close {
  position: absolute;
  right: 0.8rem;
  top: 0.2rem;
  font-size: 0.8em;
  cursor: pointer;
}
.cA98L5hbZ94cB04Zdtkl > .icon {
  position: absolute;
  font-size: 2.5rem;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--attention-color);
}
.cA98L5hbZ94cB04Zdtkl > .icon[data-type="info"] {
  color: var(--info-color);
}
.cA98L5hbZ94cB04Zdtkl > div {
  overflow-y: scroll;
  max-height: 100%;
  border-radius: var(--dry-border-radius);
  font-size: 0.8rem;
  padding: 0.2em;
}
.cA98L5hbZ94cB04Zdtkl > div em {
  display: block;
  font-weight: 500;
  background-color: var(--background);
  padding: 0.4em 0.5em;
}
.cA98L5hbZ94cB04Zdtkl .message b {
  font-weight: 600;
}
.cA98L5hbZ94cB04Zdtkl .message em {
  display: inline-flex;
}
.cA98L5hbZ94cB04Zdtkl .message pre {
  display: block;
  font-family: monospace;
  background-color: var(--background);
  padding: 0.4em 0.5em;
}
.cA98L5hbZ94cB04Zdtkl > footer {
  position: absolute;
  left: 2rem;
  right: 2rem;
  bottom: 0.5em;
  display: flex;
  justify-content: right;
  align-items: center;
  gap: 1em;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `cA98L5hbZ94cB04Zdtkl`,
	"close": `close`,
	"icon": `icon`,
	"message": `message`
};
export default ___CSS_LOADER_EXPORT___;
